module.exports = __webpack_public_path__ + "img/index-new-03.82ee6ffa.svg";